import React from 'react';
import { CustomerContactFormContent, MODE_AS_MAIN_CONTACT } from './CustomerContactFormContent';

export const CustomerMainContactCreateFormPart = () => (
    <CustomerContactFormContent mode={MODE_AS_MAIN_CONTACT} />
);
